

import "../Foundation/stylable/colors.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_180_0_SectionHeader";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_180_0_SectionHeader__root","title":"wds_1_180_0_SectionHeader__title","titleText":"wds_1_180_0_SectionHeader__titleText","suffix":"wds_1_180_0_SectionHeader__suffix"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-color-border-dark-secondary":"--wds-color-border-dark-secondary","wds-color-border-standard-primary":"--wds-color-border-standard-primary","wds-color-fill-standard-secondary":"--wds-color-fill-standard-secondary","wds-color-fill-surface-neutral":"--wds-color-fill-surface-neutral","wds-color-fill-surface-standard":"--wds-color-fill-surface-standard","wds-color-fill-surface-default":"--wds-color-fill-surface-default","wds-list-item-padding-horizontal-large":"--wds-list-item-padding-horizontal-large","wds-list-item-padding-horizontal-medium":"--wds-list-item-padding-horizontal-medium","wds-list-item-padding-horizontal-small":"--wds-list-item-padding-horizontal-small","wds-list-item-padding-horizontal-tiny":"--wds-list-item-padding-horizontal-tiny","wds-list-item-padding-horizontal-x-tiny":"--wds-list-item-padding-horizontal-x-tiny","wds-list-item-padding-horizontal-xx-tiny":"--wds-list-item-padding-horizontal-xx-tiny","wds-section-header-padding-vertical":"--wds-section-header-padding-vertical","wds-space-200":"--wds-space-200","color-bg":"--wds_1_180_0_SectionHeader-color-bg","color-border":"--wds_1_180_0_SectionHeader-color-border"}; 




